import { ThemeProvider } from '@pinwheel/origami';
import React from 'react';
import { useTheme } from './theme';
var LinkThemeProvider = function (_a) {
    var children = _a.children, _b = _a.useThemeNext, useThemeNext = _b === void 0 ? false : _b, _c = _a.useDarkMode, useDarkMode = _c === void 0 ? false : _c;
    var theme = useTheme();
    return theme ? (React.createElement(ThemeProvider, { theme: theme, useThemeNext: useThemeNext, isDarkMode: useDarkMode }, children)) : null;
};
export default LinkThemeProvider;
